import { NfcService } from "../../Everou/_services/NfcService";
import { NfcInfoMapper } from "../_mappers/NfcInfoMapper";
import { UserMapper } from "../../Everou/_mappersTS/UserMapper";
import { genericActions } from "../../Everou/_actions/generic.actions";

export const NfcActions = {
    getNfcInfo,
    updateNfcCard,
    uploadAvatarNfcCard,
};

function getNfcInfo(cardCode, rethrow = false) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, undefined, rethrow));

        async function asyncAction() {
            if (!cardCode)
                throw new Error("NO CARD CODE");

            const serverNfcInfo = await NfcService.getCardInfo(cardCode);
            return NfcInfoMapper.serverToLocal(serverNfcInfo);
        }
    };
}

function updateNfcCard(cardCode, userEmail, userName, userLastName, clockinLegalID, clockinAdditionalInfo) {
    return async dispatch => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction, undefined, true));

        async function asyncAction() {
            if (!cardCode)
                throw new Error("NO CARD CODE");

            const serverNfcInfo = await NfcService.updateCard(cardCode, userEmail, userName, userLastName, clockinLegalID, clockinAdditionalInfo);
            return NfcInfoMapper.serverToLocal(serverNfcInfo);
        }
    };
}

function uploadAvatarNfcCard(cardCode, avatar) {
    return async dispatch => {
        return dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (!cardCode)
                throw new Error("NO CARD CODE");

            const userInfo = await NfcService.uploadAvatar(cardCode, avatar);
            return UserMapper.serverToLocal(userInfo);
        }
    }
}